"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {};
exports.dialogsSlice = (0, toolkit_1.createSlice)({
    initialState,
    name: 'alerts',
    reducers: {
        openDialog: (state, action) => {
            state[action.payload.dialogId] = action.payload.data || {};
            return state;
        },
        closeDialog: (state, action) => {
            state[action.payload.dialogId] = undefined;
            return state;
        },
    },
});
//# sourceMappingURL=dialogsSlice.js.map